import { render, staticRenderFns } from "./calendarthisweek.vue?vue&type=template&id=179fd53f"
import script from "./calendarthisweek.vue?vue&type=script&lang=js"
export * from "./calendarthisweek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports